module.exports = __webpack_public_path__ + "static/media/3@1920w.cdc284a0.jpg";